import React, { createContext, Component } from 'react';
import axios from 'axios';
import { API_URL } from '../lib/const';


export const PermissionContext = createContext({
  permissions: {},
  fetchingPermissions: true,
  error: false,
  hasPermission: () => false,
  hasAllowedGroup: () => false,
});

const withPermission = WrappedComponent => class Hoc extends Component {
  state = {
    permissions: {},
    fetchingPermissions: true,
    groups: {groups:[]},
    fetchingGroups: true,
    error: false,
  }

  componentDidMount() {
    this.fetchPermissions();
    this.fetchGroups();
  }

  fetchPermissions = () =>  {
    axios.get(`${API_URL}/login/permissions`)
      .then(response => this.setState({ permissions: response.data, fetchingPermissions: false }))
      .catch(() => this.setState({ fetchingPermissions: false, error: true }));
  }

  fetchGroups = () =>  {
    axios.get(`${API_URL}/login/groups`)
      .then(response => this.setState({ groups: response.data, fetchingGroups: false }))
      .catch(() => this.setState({ fetchingGroups: false, error: true }));
  }

  hasPermission = (permission) => {
    const { permissions } = this.state;
    // eslint-disable-next-line no-underscore-dangle
    return permissions.__all__ === true || permissions[permission] === true;
  }

  hasAllowedGroup = () => {
    const { groups } = this.state;
    const dashboardGroups = [
      'convidante',
      'hospital',
      'acadêmico',
      'financeiro',
      'saúde',
      'suporte',
    ]
    const hasDashboardGroup = groups.groups.some((g) =>
      dashboardGroups.includes(g.toLowerCase())
    )
    // eslint-disable-next-line no-underscore-dangle
    return groups.is_superuser || hasDashboardGroup;
  }

  isAdmin = () => {
    const { permissions } = this.state;
    // eslint-disable-next-line no-underscore-dangle
    return permissions.__all__ === true;
  }

  render() {
    const { permissions, fetchingPermissions, fetchingGroups, groups, error } = this.state;

    if (fetchingPermissions || fetchingGroups) {
      return null;
    }

    return (
      <PermissionContext.Provider
        value={{
          error,
          fetchingPermissions,
          permissions,
          fetchingGroups,
          groups,
          hasAllowedGroup: this.hasAllowedGroup,
          hasPermission: this.hasPermission,
          isAdmin: this.isAdmin,
        }}
      >
        <WrappedComponent
          {...this.props}
          fetchingGroups={fetchingGroups}
          groups={groups}
          hasAllowedGroup={this.hasAllowedGroup}
          permissions={permissions}
          hasPermission={this.hasPermission}
          isAdmin={this.isAdmin}
        />
      </PermissionContext.Provider>
    );
  }
};

export default withPermission;
